module.exports = __webpack_public_path__ + "img/Illustration.959d527e.svg";